import dayjs from 'dayjs'

import { parseTimeToHoursMinutes } from './parseTimeToHoursMinutes'
import { VolunteeringTimeLogType } from '@percent/workplace-giving/api/opportunity/dto'

export const combineDateAndTime = (date: Date, time: string): Date => {
  const { hours, minutes } = parseTimeToHoursMinutes(time) ?? { hours: 0, minutes: 0 }

  return dayjs(date).hour(hours).minute(minutes).second(0).millisecond(0).toDate()
}

export function formatTimeLogsForSubmit(timeLogs: { date: Date; startTime: string; endTime: string }[]) {
  return timeLogs.map(({ date, startTime, endTime }) => ({
    startTime: combineDateAndTime(date, startTime),
    endTime: combineDateAndTime(date, endTime)
  }))
}

export function buildSubmitPayload(
  platform: VolunteeringTimeLogType,
  formattedTimeLogs: { startTime: Date; endTime: Date }[],
  duringWorkingHours: boolean | undefined,
  data: {
    organisationId?: string
    activities?: string[]
    skills?: string[]
    opportunityId?: string
  }
) {
  const baseProps = {
    timeLogs: formattedTimeLogs,
    duringWorkingHours
  }

  if (platform === VolunteeringTimeLogType.OffPlatform) {
    return {
      ...baseProps,
      platform,
      organisationId: data.organisationId?.length ? data.organisationId : undefined,
      activities: data.activities as string[],
      skills: data.skills as string[]
    }
  }

  return {
    ...baseProps,
    platform,
    opportunityId: data.opportunityId as string
  }
}
